import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';
import { CarType, PagingType, SearchCriteriaType, SortType } from '../types/oneGraphTypes';

interface VehicleReducerTypes {
  vehiclesList: CarType[] | null;
  totalCount: number | null;
  pagination: PagingType;
  sortBy: SortType;
  availableFilters: SearchCriteriaType[] | null;
}

const initialState: VehicleReducerTypes = {
  vehiclesList: null,
  totalCount: null,
  pagination: {
    limit: 12,
    offset: 0,
  },
  sortBy: {
    direction: 'ASC',
    id: 'BY_DISTANCE',
    value: 'byDistance:ASC',
  },
  availableFilters: null,
};

const vehiclesOneGrpahSlice = createSlice({
  name: 'vehiclesOneGraph',
  initialState,
  reducers: {
    setVehicleList: (state, action: PayloadAction<CarType[]>) => {
      return { ...state, vehiclesList: action.payload };
    },
    addMoreVehicles: (state, action: PayloadAction<CarType[]>) => {
      const currentVehicles = state.vehiclesList || [];
      const newVehiclesList = [...currentVehicles, ...action.payload];
      return { ...state, vehiclesList: newVehiclesList };
    },
    setPossibleFilters: (state, action: PayloadAction<SearchCriteriaType[] | null>) => {
      return { ...state, availableFilters: action.payload };
    },
    setTotalCount: (state, action: PayloadAction<number | null>) => {
      return { ...state, totalCount: action.payload };
    },
    setPagination: (state, action: PayloadAction<PagingType>) => {
      return { ...state, pagination: action.payload };
    },
    setSortBy: (state, action: PayloadAction<SortType>) => {
      return { ...state, sortBy: action.payload };
    },
  },
});

export const selectVehiclesOneGraph = (state: RootState) => state.vehiclesOneGraph;

export const {
  setVehicleList,
  addMoreVehicles,
  setPossibleFilters,
  setTotalCount,
  setPagination,
  setSortBy,
} = vehiclesOneGrpahSlice.actions;

export default vehiclesOneGrpahSlice.reducer;
